import {
	LANDING_AMPLITUDE_EVENTS,
	LANDING_COOKIE_STORAGE,
	LOCAL_STORAGE_KEYS,
} from '@/constants';
import benefit from '@/public/images/video-to-text/benefits.webp';
import howWork from '@/public/images/video-to-text/howItWorks.webp';
import whyLift from '@/public/images/video-to-text/whyLift.webp';
import { type LandingConfigItem } from '../../types';
import { exploreConfig } from './exploreConfig';
import { tryLiftConfig } from './tryLiftConfig';

export const landingVideoToTextConfig: LandingConfigItem = {
	id: 'video-to-text',
	translationLocale: 'video-to-text',
	withDropZone: false,
	mediaCookieKey: LANDING_COOKIE_STORAGE.SPEECH_TO_TEXT_FROM_LANDING,
	hero: {
		type: 'speechToText',
		title: 'heroData_title',
		description: 'heroData_subtitle',
		buttonText: 'heroData_buttonText',
		background: true,
		data: {
			fileTab: 'heroData_fileTab',
			linkTab: 'heroData_linkTab',
			dropzoneTitle: 'heroData_dropzoneTitle',
			durationLabel: 'heroData_durationLabel',
			sizeLabel: 'heroData_sizeLabel',
			inputPlaceholder: 'heroData_inputPlaceholder',
			trustBadge1: 'heroData_trustBadge1',
			trustBadge2: 'heroData_trustBadge2',
		},
	},
	howItWork: {
		title: 'howItWorkData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '📁',
				title: 'howItWorkData_title1',
				subtitle: 'howItWorkData_subtitle1',
			},
			{
				icon: '⚙️',
				title: 'howItWorkData_title2',
				subtitle: 'howItWorkData_subtitle2',
			},
			{
				icon: '✨',
				title: 'howItWorkData_title3',
				subtitle: 'howItWorkData_subtitle3',
			},
			{
				icon: '🤘',
				title: 'howItWorkData_title4',
				subtitle: 'howItWorkData_subtitle4',
			},
		],
		images: [
			{
				image: howWork,
				title: 'howItWorkData_imageTitle',
				alt: 'howItWorkData_imageAlt',
			},
		],
	},
	benefits: {
		title: 'benefitData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{ icon: '🔹', subtitle: 'benefitData_subtitle1' },
			{ icon: '🔹', subtitle: 'benefitData_subtitle2' },
			{ icon: '🔹', subtitle: 'benefitData_subtitle3' },
			{ icon: '🔹', subtitle: 'benefitData_subtitle4' },
			{ icon: '🔹', subtitle: 'benefitData_subtitle5' },
		],
		images: [
			{
				image: benefit,
				title: 'benefitData_imageTitle',
				alt: 'benefitData_imageAlt',
			},
		],
	},
	faq: {
		title: 'faqData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{ title: 'faqData_title1', subtitle: 'faqData_subtitle1' },
			{ title: 'faqData_title2', subtitle: 'faqData_subtitle2' },
			{ title: 'faqData_title3', subtitle: 'faqData_subtitle3' },
			{ title: 'faqData_title4', subtitle: 'faqData_subtitle4' },
			{ title: 'faqData_title5', subtitle: 'faqData_subtitle5' },
		],
	},
	whyLift: {
		title: 'whyUseData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✅',
				title: 'whyUseData_title1',
				subtitle: 'whyUseData_subtitle1',
			},
			{
				icon: '✅',
				title: 'whyUseData_title2',
				subtitle: 'whyUseData_subtitle2',
			},
			{
				icon: '✅',
				title: 'whyUseData_title3',
				subtitle: 'whyUseData_subtitle3',
			},
			{
				icon: '✅',
				title: 'whyUseData_title4',
				subtitle: 'whyUseData_subtitle4',
			},
		],
		images: [
			{
				image: whyLift,
				title: 'whyUseData_imageTitle',
				alt: 'whyUseData_imageAlt',
			},
		],
	},
	explore: {
		...exploreConfig,
	},
	tryLift: {
		...tryLiftConfig,
	},
	analytics: {
		scrolledPercentName: LOCAL_STORAGE_KEYS.VIDEO_TO_TEXT_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.VIDEO_TO_TEXT,
		galleryContext: LANDING_AMPLITUDE_EVENTS.VIDEO_TO_TEXT_LANDING,
	},
};
